import { Unit } from "uom";
// Sound pressure level
export var Decibel = Unit.createBase("Decibel", "SoundPressureLevel", "dB");
//# sourceMappingURL=sound-pressure-level.js.map